export const videos = [
  {
    id: 1,
    title: 'Welcome to The Tiny Times!',
    description: 'Discover what makes our children\'s magazine special! Join us on a journey of fun, learning, and adventure.',
    youtubeId: 'dQw4w9WgXcQ', // Replace with actual YouTube video ID
    thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg',
    category: 'behindthescenes',
    duration: '3:45',
    views: '1.2K',
    publishedAt: '2024-01-15',
    featured: true,
  },
  {
    id: 2,
    title: 'The Brave Little Turtle - Animated Story',
    description: 'Watch the animated version of our most popular story! Join Timmy the turtle on his adventure.',
    youtubeId: 'dQw4w9WgXcQ', // Replace with actual YouTube video ID
    thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg',
    category: 'stories',
    duration: '5:20',
    views: '3.5K',
    publishedAt: '2024-01-20',
    featured: false,
  },
  {
    id: 3,
    title: 'DIY Paper Craft Tutorial',
    description: 'Learn how to make amazing paper crafts with simple materials! Perfect for kids of all ages.',
    youtubeId: 'dQw4w9WgXcQ', // Replace with actual YouTube video ID
    thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg',
    category: 'activities',
    duration: '8:15',
    views: '2.1K',
    publishedAt: '2024-01-25',
    featured: false,
  },
  {
    id: 4,
    title: 'Puzzle Challenge: Can You Solve It?',
    description: 'Test your brain with this fun puzzle challenge! Pause the video and try to solve it yourself.',
    youtubeId: 'dQw4w9WgXcQ', // Replace with actual YouTube video ID
    thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg',
    category: 'puzzles',
    duration: '4:30',
    views: '1.8K',
    publishedAt: '2024-02-01',
    featured: true,
  },
  {
    id: 5,
    title: 'How We Create The Tiny Times',
    description: 'Ever wondered how we make each issue? Take a peek behind the scenes of our creative process!',
    youtubeId: 'dQw4w9WgXcQ', // Replace with actual YouTube video ID
    thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg',
    category: 'behindthescenes',
    duration: '6:45',
    views: '950',
    publishedAt: '2024-02-05',
    featured: false,
  },
  {
    id: 6,
    title: 'Learn Colors with Rainbow Friends',
    description: 'A fun and educational video for young learners! Learn colors through songs and activities.',
    youtubeId: 'dQw4w9WgXcQ', // Replace with actual YouTube video ID
    thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg',
    category: 'tutorials',
    duration: '7:00',
    views: '4.2K',
    publishedAt: '2024-02-10',
    featured: false,
  },
  {
    id: 7,
    title: 'The Magic Garden - Story Time',
    description: 'Join us for a magical story about friendship, nature, and adventure in the enchanted garden.',
    youtubeId: 'dQw4w9WgXcQ', // Replace with actual YouTube video ID
    thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg',
    category: 'stories',
    duration: '6:20',
    views: '2.8K',
    publishedAt: '2024-02-15',
    featured: false,
  },
  {
    id: 8,
    title: 'Easy Science Experiment: Volcano',
    description: 'Make your own volcano at home with simple ingredients! A fun science experiment for kids.',
    youtubeId: 'dQw4w9WgXcQ', // Replace with actual YouTube video ID
    thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg',
    category: 'activities',
    duration: '5:45',
    views: '3.1K',
    publishedAt: '2024-02-20',
    featured: false,
  },
];

// Helper function to get featured videos
export const getFeaturedVideos = () => {
  return videos.filter(video => video.featured);
};

// Helper function to get videos by category
export const getVideosByCategory = (category) => {
  if (category === 'all') return videos;
  return videos.filter(video => video.category === category);
};

// Helper function to get latest videos
export const getLatestVideos = (count = 4) => {
  return [...videos]
    .sort((a, b) => new Date(b.publishedAt) - new Date(a.publishedAt))
    .slice(0, count);
};